import { isKeycloakEnabled } from "@configs/Env";

let keycloakInitialized = false;

export function setKeycloakInitialized(value: boolean): void {
  keycloakInitialized = value;
}

/** Keycloak 비활성이거나 init 이 끝난 뒤에만 API/query 실행을 허용한다. */
export function isKeycloakInitComplete(): boolean {
  if (!isKeycloakEnabled()) return true;
  return keycloakInitialized;
}
